import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { LangProvider } from './i18n';
import './styles/tokens.css';
import './styles/fonts.css';
import './styles/global.css';
import '@phosphor-icons/web/regular';
import '@phosphor-icons/web/bold';
import '@phosphor-icons/web/fill';

// Build-Stamp damit CF Pages bei jedem Deploy ein frisches Bundle hat.
// Siehe /00_TRO_DEV_DOCS/tech-stack.md → "Build-Stamp im Bundle".
(window as unknown as { __BUILD__: string }).__BUILD__ = new Date().toISOString();

const root = document.getElementById('root');
if (!root) throw new Error('root element missing');

createRoot(root).render(
  <StrictMode>
    <BrowserRouter>
      <LangProvider>
        <App />
      </LangProvider>
    </BrowserRouter>
  </StrictMode>,
);
